/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorRequestDialog.vue?vue&type=template&id=66d290c7&scoped=true"
import script from "./DoctorRequestDialog.vue?vue&type=script&lang=js"
export * from "./DoctorRequestDialog.vue?vue&type=script&lang=js"
import style0 from "./DoctorRequestDialog.vue?vue&type=style&index=0&id=66d290c7&scoped=true&lang=css"
import style1 from "./DoctorRequestDialog.vue?vue&type=style&index=1&id=66d290c7&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d290c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d290c7')) {
      api.createRecord('66d290c7', component.options)
    } else {
      api.reload('66d290c7', component.options)
    }
    module.hot.accept("./DoctorRequestDialog.vue?vue&type=template&id=66d290c7&scoped=true", function () {
      api.rerender('66d290c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/DoctorRequestDialog.vue"
export default component.exports